import EnrolementForm from "../Components/EnrolementForm/EnrolementForm";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import "./app.scss";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";

function App() {
  const theme = createMuiTheme({
    palette: {
      primary: {
        main: "#5096FF",
      },
    },
  });

  return (
    <div className="app">
      <MuiThemeProvider theme={theme}>
        <img src="logo_dag.png" style={{ width: "100px" }} alt="image" />
        <EnrolementForm />
      </MuiThemeProvider>
    </div>
  );
}

export default App;
